interface PropertyValue {
  value?: string
  richText?: string
  blocks?: any[] // For BasicBlockListModel
  elements?: any[] // For BasicNestedContent
  mediaItems?: { url: string }[]
  links?: []
  dateTime?: string
  contentList?: any
}

interface DataProperty {
  propertyName: string | null
  propertyValue: PropertyValue | null
}

interface Data {
  properties?: DataProperty[]
}

export function extractProperty(data: Data | any, propertyName: string, allMedia?: boolean): any {
  if (!data || !propertyName) {
    return ""
  }

  const property = data.properties?.find((prop: DataProperty) => prop.propertyName === propertyName)

  if (!property?.propertyValue) {
    return ""
  }
  if (allMedia) {
    return property.propertyValue.mediaItems
  }

  const pv = property.propertyValue as any

  // Boolean values (toggles) must be returned directly — the || chain
  // below short-circuits false to the next branch (ASH-2087).
  if (typeof pv?.value === "boolean") {
    return pv.value
  }

  // Attempt extraction in the given order
  return (
    pv?.value ||
    pv?.richText ||
    pv?.integer ||
    pv?.decimal ||
    (typeof pv === "number" ? pv : null) ||
    (typeof pv === "string" ? pv : null) ||
    pv?.mediaItems?.[0]?.url ||
    pv?.blocks || // For BasicBlockListModel
    pv?.elements || // For BasicNestedContent
    pv?.links ||
    pv?.dateTime ||
    pv?.contentList ||
    ""
  )
}
